/*
 *  I15TEMPLIMITBOISReducer.ts
 *
 *  Created by Sébastien Hecart on 2022-06-18 14:40:46 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I15TEMPLIMITBOIS_State } from '@batical/types/src'

const I15TEMPLIMITBOIS: I15TEMPLIMITBOIS_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_deperdition: 10.0,
  in_temp_consigne: 10.0,
  in_puissance_chaudiere: 10.0,
  in_modulation_min: 10.0,
  in_tempExtBase: 0.0,
  res_tempReleveAppoint: 0.0,
  mode: 'none',
  calcul_code: 'I15TEMPLIMITBOIS'
}

export default I15TEMPLIMITBOIS
